import { CUSTOM_CHANNEL } from '@disco/constants/GroupTypes'
import { getEnabledFolders } from '@disco/utils/groups'
import * as React from 'react'
import { connect } from 'react-redux'
import type { Group, GroupWithNesting } from 'types/group'
import type { Playlist } from 'types/playlist'
import type { Track } from 'types/track'
import { getGroups } from '@disco/state-management/selectors/groups'
import ChannelSelector from 'components/common/channel-selector'
import Label from 'components/ui/label'
import ModalDialog from 'components/ui/modal-dialog'
type Props = {
  allGroups: Group[]
  groups: GroupWithNesting[]
  onSubmit: (...args: Array<any>) => any
  onClose: (...args: Array<any>) => any
  source?: Playlist | Track
  type: 'add' | 'copy'
}
type OwnState = {
  selectedChannels: Record<string, any>[]
}

/**
 * Modal component for adding or copying playlists/tracks to custom channels
 * Provides channel selection interface with filtering and permission checks
 * @param allGroups - All available groups for folder filtering
 * @param groups - Groups with nesting structure for channel selection
 * @param onSubmit - Callback when channels are selected and submitted
 * @param onClose - Callback to close the modal
 * @param source - Source playlist or track being added/copied
 * @param type - Operation type: 'add' or 'copy'
 */
class AddToChannelModal extends React.Component<Props, OwnState> {
  state = {
    selectedChannels: [],
  }
  _onSubmit = () => {
    this.props.onSubmit(this.state.selectedChannels)
  }

  _isInActiveGroups(group) {
    const { source } = this.props
    if (!source || !source.groups) return false
    return source.groups.some(activeGroup => {
      return activeGroup && activeGroup === group.url
    })
  }

  _getChannels() {
    const channels = this.props.groups.filter(
      group =>
        group.group_type === CUSTOM_CHANNEL &&
        !group.parent &&
        group.permissions.content,
    )
    return getEnabledFolders(
      this.props.allGroups,
      channels,
      g => !this._isInActiveGroups(g),
    )
  }

  _updateSelection = value => {
    this.setState({
      selectedChannels: value,
    })
  }

  render() {
    const groups = this._getChannels()

    const caption = `${this.props.type === 'copy' ? 'Copy' : 'Add'} to channel`
    return (
      <ModalDialog
        title={caption}
        primaryAction={{
          caption,
          disabled: this.state.selectedChannels.length === 0,
          onClick: this._onSubmit,
        }}
        onCancel={this.props.onClose}
      >
        <Label caption="Channel" />
        <ChannelSelector
          autoFocus
          // @ts-expect-error
          channels={groups}
          placeholder="Select or begin typing Channel name"
          selectedChannels={this.state.selectedChannels}
          onChannelSelect={this._updateSelection}
        />
      </ModalDialog>
    )
  }
}

export default connect(state => ({
  allGroups: getGroups(state),
}))(AddToChannelModal) as any
